interface IMenuItemBase {
  title: string;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  rightIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  isActive?: boolean;
  className?: string;
  subMenu?: boolean;
}

interface ILinkMenuItem extends IMenuItemBase {
  link: string;
  onClick?: () => void;
  target?: string;
  external?: boolean;
  rel?: string;
}

export interface IMenuItem extends IMenuItemBase {
  link?: string;
  onClick?: () => void;
  target?: string;
  external?: boolean;
}

export const isLinkMenuItem = (item: IMenuItem): item is ILinkMenuItem => "link" in item && Boolean(item.link);
